import React, { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Search from '../Search';

const feedSignature = () => JSON.stringify(['token', 'currentFilter', 'settingsRevision', 'theme'].map(key => localStorage.getItem(key)));

// Retain the native feed while another screen is open, including its articles,
// draft filters and scroll position. Account/settings/filter changes invalidate it.
export default function NativeHome() {
  const location = useLocation();
  const home = location.pathname === '/';
  const visited = useRef(false);
  const revision = useRef(0);
  const previous = useRef(feedSignature());
  const wasHome = useRef(false);
  const search = useRef(location.search);
  const scroll = useRef(0);
  if (home) {
    visited.current = true;
    if ((!wasHome.current && previous.current !== feedSignature()) || search.current !== location.search) {
      revision.current += 1;
      scroll.current = 0;
    }
    search.current = location.search;
  }
  wasHome.current = home;
  useLayoutEffect(() => {
    if (!home) return undefined;
    window.scrollTo(0, scroll.current);
    const rememberScroll = () => { scroll.current = window.scrollY; };
    window.addEventListener('scroll', rememberScroll, { passive: true });
    return () => {
      previous.current = feedSignature();
      window.removeEventListener('scroll', rememberScroll);
    };
  }, [home]);
  return visited.current ? <div hidden={!home}><Search key={revision.current} active={home} /></div> : null;
}
